var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.forbidden},[_c('div',{class:_vm.$style.tipText},[_vm._v("没有访问权限")])])
}
var staticRenderFns = []

export { render, staticRenderFns }